<template>
  <canvas ref="grid" class="app__grid grid"></canvas>
</template>

<script>
import Shaky from '@/assets/libs/shaky';

export default {
  name: 'AppGrid',

  data() {
    return {
      shaky: null,
      interval: -1,
      hLines: window.innerWidth < 768 ? 5 : 16,
      vLines: 9,
    };
  },

  mounted() {
    this.$nextTick(() => {
      this.shaky = new Shaky(this.$refs.grid);
      this.shaky.segSize = 3;
      this.shaky.shake = 2.5;

      this.resize();
      this.$eventHub.$on('windowResize', () => this.resize());

      this.drawGrid();
      this.interval = setInterval(this.drawGrid, 100);
    });
  },

  methods: {
    drawGrid() {
      if (this.$refs.grid === undefined) return;

      this.shaky.clear();
      const canvasRect = this.$refs.grid.getBoundingClientRect();
      const hUnit = canvasRect.width / this.hLines;
      const vUnit = canvasRect.height / this.vLines;
      this.shaky.context.strokeStyle = '#ECDDD0';
      // Draw horizontal lines
      for (let i = 0; i < this.hLines; i += 1) {
        this.shaky.beginPath();
        this.shaky.moveTo(hUnit * i, 0);
        this.shaky.lineTo(hUnit * i, canvasRect.height);
        this.shaky.stroke();
      }
      // Draw vertical lines
      for (let i = 0; i < this.vLines; i += 1) {
        this.shaky.beginPath();
        this.shaky.moveTo(0, vUnit * i);
        this.shaky.lineTo(canvasRect.width, vUnit * i);
        this.shaky.stroke();
      }
    },
    resize() {
      if (this.$refs.grid === undefined) return;

      const canvasRect = this.$refs.grid.getBoundingClientRect();
      this.shaky.setSize(canvasRect.width, canvasRect.height);
      this.hLines = window.innerWidth < 768 ? 5 : 16;
    },
  },
};
</script>

<style lang="scss" scoped>
.grid {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
</style>
